import { Component } from 'react';
import { IAppState } from './IAppState';
import { ILobbyState } from './ILobbyState';
import { ILobbyTournamentState } from './ILobbyTournamentState';
import { ILobbyTournamentRankingsState } from './ILobbyTournamentRankingsState';
import i18n from '../../i18n';

export class AppStateModel {
    public app: Component<{}, IAppState>;

    constructor(app: Component<{}, IAppState>) {
        this.app = app;
    }

    public static getInitialState(): IAppState {
        const initialLobbyState: ILobbyState = {
            chatMessages: [],
            rooms: []
        };
        const initialLobbyTournamentState: ILobbyTournamentState = {
            tournaments: [],
            chatMessages: []
        };
        const initialLobbyTournamentRankingsState: ILobbyTournamentRankingsState = {
            type: 'tournamentRankings',
            tournaments: []
        };

        return {
            userConnectedCount: 0,
            connected: false,
            isLoading: false,
            user: {
                id: '',
                authenticated: false,
                username: '',
                firstname: '',
                lastname: '',
                balance: 0,
                hasCredentialError: false,
                avatarUrl: '',
                hasFocedLogoutMaxClients: false,
                singleViewRoomId: null,
                singleViewCasinoGameId: null,
                section: 'login',
                isProfileOpen: false,
                tickets: [],
                pokerUserSettings: {
                    clientVolume: 0.7,
                    notificationFrequency: 1,
                    language: 'en'
                }
            },
            lobby: initialLobbyState,
            lobbyTournament: initialLobbyTournamentState,
            lobbyTournamentRankings: initialLobbyTournamentRankingsState,
            joinedRooms: [],
            casinoSessions: [],
            language: i18n.language || 'en',
            loginConflict: null
        };
    }

    public resetState = () => {
        this.app.setState(AppStateModel.getInitialState());
    }

    public setState = (state: IAppState) => {
        this.app.setState(state);
    }
}
